import { menuService } from '../network/services/menu.service';
import {ResponseError} from "../network/response/response-error";

export default {
  namespaced: true,
  state: {
    loading: true,
    indexActive: 0,
    concept: [],
    blogArticles: [],
    roomZones: [],
    instagram: [],
  },
  mutations: {
    SET_MENU_ACTIVE(state, payload) {
      state.indexActive = parseInt(payload);
    },
    SET_CONCEPT(state, payload) {
      state.concept = payload;
    },
    SET_BLOG_ARTICLES(state, payload) {
      state.blogArticles = payload;
    },
    SET_ROOM_ZONES(state, payload) {
      state.roomZones = payload;
    },
    SET_INSTAGRAM(state, payload) {
      state.instagram = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
  },
  actions: {
    async fetch({ commit }, lang) {
      commit('SET_LOADING', true);
      const response = await menuService.fetch(lang);
      const conceptMenu = response.get('ConceptMenu.many', []);
      const blogArticles = response.get('BlogArticle.many', []);
      const roomZones = response.get('RoomZone.many', []);
      const instagram = response.get('InstagramTag.many', []);
      if (conceptMenu instanceof ResponseError) {
        // TODO catch errors
      } else {
        commit('SET_CONCEPT', conceptMenu);
      }
      if (blogArticles instanceof ResponseError) {
        // TODO catch errors
      } else {
        commit('SET_BLOG_ARTICLES', blogArticles);
      }
      if (roomZones instanceof ResponseError) {
        // TODO catch errors
      } else {
        commit('SET_ROOM_ZONES', roomZones);
        commit('search/SET_AVAILABLE_ROOM_ZONES', roomZones, {root: true});
      }
      if (instagram instanceof ResponseError) {
        // TODO catch errors
      } else {
        commit('SET_INSTAGRAM', instagram);
      }
      commit('SET_LOADING', false);
    },
    setIndexActive({ commit }, index) {
      commit('SET_MENU_ACTIVE', index);
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/menu.store.js